import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { GlobalConstants } from '../app.component';

@Injectable()
export class AuthorizationCheck implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    //If token data exist, user may login to application
    if (GlobalConstants.Tid.length < 1) {
      this.router.navigate(['/accessdenied']);
      return false;
    }

    if (GlobalConstants.Jwi.length > 0)
      return true;

    // otherwise redirect to login page with the return url
    //this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

}
